@let customCollectionActionsTemplate = customCollectionActionsTemplateRef();
@let customCollectionActions = customActionsTemplateRef();

@if (
  !isNil(customCollectionActionsTemplate) || !isNil(customCollectionActions)
) {
  <app-table-header
    [actions]="actions"
    [customActionsTemplateRef]="customCollectionActions"
    [customCollectionActionsTemplateRef]="customCollectionActionsTemplate"
    [selection]="selection$ | async" />
} @else {
  @if (
    selection$ | tableHeaderVisibility: actions : collectionActions | async
  ) {
    <app-table-header
      [actions]="actions"
      [collectionActions]="collectionActions"
      [selection]="selection$ | async" />
  }
}

<p-table
  [class]="'p-datatable-layout-' + responsiveLayout"
  (onLazyLoad)="handleLazeLoad($event)"
  (onRowReorder)="handeRowReorder($event)"
  (selectionChangeEvent)="handleSelectionChangeEvent($event)"
  [bodyRowSelectionDisabledFn]="bodyRowSelectionDisabledFn"
  [dataKey]="$any(dataKey)"
  [first]="first()"
  [lazy]="true"
  [rowHover]="true"
  [rows]="rows()"
  [scrollable]="true"
  [preserveSelectionOnFilter]="preserveSelectionOnFilter"
  [topScrollEnabled]="topScrollEnabled"
  [totalRecords]="total()"
  [value]="data()"
  [scrollHeight]="scrollHeight"
  appTableCurrentPageRowsSelection
  appTableTopContentScroll>
  <ng-template #header>
    <tr
      (sortClearEvent)="handleClearSortEvent()"
      [columns]="columns"
      [reordering]="reordering"
      [appendLabels]="enabledStackResponsiveLayout()"
      app-table-header-row></tr>

    @if (filtering) {
      <tr
        (changes)="handleFilterChanges($event)"
        [columns]="columns"
        [filters]="filters"
        [reordering]="reordering"
        app-table-filter-row></tr>
    }
  </ng-template>

  <ng-template
    #body
    let-index="rowIndex"
    let-row>
    <tr
      [bodyRowSelectionDisabled]="
        row | bodyRowSelectionDisabled: bodyRowSelectionDisabledFn
      "
      [columns]="columns"
      [customCellTemplateRef]="customCellTemplateRef()"
      [dataKey]="dataKey"
      [first]="first()"
      [index]="index"
      [itemActions]="itemActions"
      [model]="row"
      [ngClass]="row | bodyRowCssClass: bodyRowCssClassFn"
      [pReorderableRowDisabled]="!reordering"
      [pReorderableRow]="index"
      [reordering]="reordering"
      [appendLabels]="enabledStackResponsiveLayout()"
      app-table-body-row></tr>
  </ng-template>

  <ng-template #emptymessage>
    @if (isFirstLoaded) {
      <tr
        [columns]="columns"
        [reordering]="reordering"
        app-table-empty-message-row></tr>
    }
  </ng-template>
</p-table>

@if (pagination) {
  @if (isFirstLoaded) {
    <app-table-paginator
      (pageChange)="handlePageChange($event)"
      [first]="first()"
      [rows]="rows()"
      [total]="total()" />
  }
}
